import { render, staticRenderFns } from "./EcoleJA.vue?vue&type=template&id=414665e0&scoped=true"
import script from "./EcoleJA.vue?vue&type=script&lang=js"
export * from "./EcoleJA.vue?vue&type=script&lang=js"
import style0 from "./EcoleJA.vue?vue&type=style&index=0&id=414665e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_cache-loader@4.1.0_webpack@4.47.0__css-load_310753db291b809859cbd9e654a8ef6f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414665e0",
  null
  
)

export default component.exports